import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';

export function useDeleteContact(contactId: string, onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutationApi<void, void>({
    endpoint: `contacts/${contactId}`,
    method: 'DELETE',
    successMessage: 'Contact deleted successfully',
    errorMessage: 'Failed to delete contact',
    options: {
      // NOTE: params _data/_variables/_context currently unused (kept via '_' prefix) — revisit and delete if not needed
      onSuccess: (_data, _variables, _context) => {
        // Invalidate contacts queries to refresh the data
        queryClient.invalidateQueries({
          queryKey: ['contacts'],
        });
        onSuccess?.();
      },
    },
  });
}

export default useDeleteContact;
